/**
 * @generated SignedSource<<65f76356f7fa53bdeb78dd2726710c82>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CommentsModeEnum = "qa" | "standard" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CskCoralSectionContainer_contentResource$data = {
  readonly chorusId: number | null;
  readonly chorusUuid: string | null;
  readonly comments: {
    readonly enabled: boolean;
    readonly mode: CommentsModeEnum;
  };
  readonly globalId: string;
  readonly id: string;
  readonly permalink: string;
  readonly " $fragmentType": "CskCoralSectionContainer_contentResource";
};
export type CskCoralSectionContainer_contentResource$key = {
  readonly " $data"?: CskCoralSectionContainer_contentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"CskCoralSectionContainer_contentResource">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CskCoralSectionContainer_contentResource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chorusId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chorusUuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "globalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permalink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentsType",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentResourceInterface",
  "abstractKey": "__isContentResourceInterface"
};

(node as any).hash = "1309c22b83bf0f91b947c6a737184eff";

export default node;
